var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.value)?_c('v-chip',{staticClass:"trend-tag",style:({'background-color': '#4A4848'}),attrs:{"close":_vm.isEditMode,"dark":"","label":"","text-color":"white"},on:{"click:close":_vm.onClose}},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }